import Vue from "vue";

import { URL_API } from "../../settings/apiConnect";

export default {
  actions: {
    async getServiceOrganizationsData(context) {
      const response = await Vue.axios.get(`${URL_API}serviceorganization`);
      let data = response["data"];
      context.commit("updateServiceOrganizationsData", data);
    },
    async createServiceOrganizationData(context, name) {
      const config = {};
      const body = {
        name: name
      };
      await Vue.axios.post(`${URL_API}serviceorganization/store`, body, config);
      context.dispatch("getServiceOrganizationsData");
    },
    async pushServiceOrganizationData(context, { id, name }) {
      const config = {};
      const body = {
        id: id,
        name: name
      };
      await Vue.axios.post(`${URL_API}serviceorganization/update`, body, config);
      context.dispatch("getServiceOrganizationsData");
    },
    async destroyServiceOrganizationData(context, id) {
      const config = {};
      const body = {
        id: id
      };
      await Vue.axios.post(`${URL_API}serviceorganization/destroy`, body, config);
      context.dispatch("getServiceOrganizationsData");
    }
  },
  mutations: {
    updateServiceOrganizationsData(state, serviceOrganizationsData) {
      state.serviceOrganizationsData = serviceOrganizationsData;
    }
  },
  state: {
    serviceOrganizationsData: []
  },
  getters: {
    allServiceOrganizationsData(state) {
      return state.serviceOrganizationsData;
    }
  }
};
